<template>

        <div class="container mt-2 clearfix">

            <template  v-if="!salvandoLote && !itens.length">

                <label class="btn btn-default btn-xs-block white-text">
                    <input type="file" hidden @change="enviarCsv($event)" accept=".csv">
                    Selecionar CSV
                </label>
                &nbsp;
                <button class="btn btn-default btn-xs-block" @click="exportarModelo">
                    <i class="material-icons left">cloud_download</i>
                    <span class="mt-1">Exportar Modelo</span>
                </button>
                &nbsp;

                <div class="card-panel">
                    Observação: Nomes duplicados serão ignorados no momento da confirmação da importação.
                </div>

                <div class="flex-row">
                    <div class="col-xs-12 col-md-6">
                        <div class="card-panel">
                            <h5 class="m-0">Campos do CSV</h5>
                            <table class='table bordered' style="table-layout: auto;">
                                <tbody>
                                    <tr v-for="(value, key) in campos" :key="key">
                                        <th width="15%">{{ key }}</th>
                                        <td>{{ value || '&nbsp;' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-xs-12 col-md-6">
                        <div class="card-panel">
                            <h5 class="m-0">Funcionários</h5>
                            <div>
                                <input v-model.trim="pesquisa_funcionarios.pessoa_nome" type="text" placeholder="Pesquisar Funcionário" class="input-default" @input="carregarFuncionarios">
                            </div>
                            <table class='table bordered' style="table-layout: auto;">
                                <thead>
                                    <th>ID</th>
                                    <th>Nome</th>
                                </thead>
                                <tbody>
                                    <tr v-for="funcionario in funcionarios.data" :key="`fun-${funcionario.funcionario_id}`">
                                        <td>{{ funcionario.funcionario_id }}</td>
                                        <td>{{ funcionario.pessoa.pessoa_nome }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="!salvandoLote && itens.length > 0">
                <div class="card-panel">
                    <input type="text" class="form-control" placeholder="Pesquisar" v-model.trim="filtro" @input="() => paginacao.pagina = 1">
                </div>

                <div class="mt-1 mb-1 right-align">
                    <button class="btn white text-default btn-xs-block" @click="() => itens = []">
                        <i class="material-icons left">delete</i>
                        Descartar
                    </button>
                    &nbsp;
                    <button class="btn btn-default btn-xs-block" @click="salvarLote" v-if="itens.length > 0">
                        Salvar
                    </button>
                </div>

                <div class="card-panel" v-if="itensPaginado.length">
                    <h4 class="header m-0 mb-1">Dados importados</h4>
                    <div class="table-responsive">
                        <table class='table  striped bordered' style="table-layout: auto;">
                            <thead>
                                <tr v-once>
                                    <th v-for="campo in nomeCampos" :key="`cabecalho-${campo}`">{{ campo.toUpperCase() }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in itensPaginado" :key="`tr-item-${index}`" >
                                    <td
                                        v-for="campo in nomeCampos" :key="`td-item-${campo}-${index}`"
                                        :title="item.erros[campo] ? item.erros[campo][0] : 'Campo válido'"
                                        :style="{color: item.erros[campo] ? 'red' : undefined}">{{ item.dados[campo] }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <Pagination :perPage="paginacao.limite" :qty="itensFiltrados.length" :setCurrent="(pagina) => paginacao.pagina = pagina" :current.sync="paginacao.pagina" />
                </div>
                <div v-else>
                    Nenhum resultado encontrado
                </div>
            </template>

            <template v-if="salvandoLote">
                <div class="card-panel center">
                    Salvando...
                    <pulse-loader :loading="true" :color="blue" :size="size" />
                </div>
            </template>


        </div>

</template>
<style>
  .table-responsive{
      overflow: auto;
  }
</style>
<script>

import {api} from "@/helpers/api";
import { debounce } from "lodash"
import Pagination from '@/components/common/Pagination/Pagination';
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'

export default {

    components: { Pagination, PulseLoader },

    computed: {

        limitePaginacao() {
            return Math.ceil(this.itens.length / this.paginacao.limite);
        },

        itensPaginado()
        {
            const index = this.paginacao.pagina * this.paginacao.limite;

            return this.itensFiltrados.slice(index - this.paginacao.limite, index)
        },

        itensFiltrados() {

            const termo = this.filtro.toLowerCase();

            return this.itens.filter(item => (item.dados.pessoa_nome || '').toLowerCase().includes(termo))
        },

        nomeCampos() {

            return Object.keys(this.campos);
        },
    },

    async created() {

        this.carregarFuncionarios();
    },


    data() {
        return {
            filtro: '',
            paginacao: {
                limite: 20,
                pagina: 1,
            },
            itens: [],
            campos: {
                'pessoa_nome' : 'Obrigatório',
                'pessoa_profissao' : '',
                'pessoa_cpf' : '',
                'pessoa_email' : 'Obrigatório',
                'pessoa_estado_civil' : 'O campo deve ser C (Casado), S (Solteiro), D (Divorciado), V (Viúvo), O (Outros), SJ (Separado Judicialmente), UE (UNIÃO ESTÁVEL)',
                'pessoa_sexo' : 'O campo deve ser M ou F',
                'pessoa_telefone' : 'O campo deve ser numérico, contendo 10 caracteres;',
                'pessoa_celular' : 'O campo deve ser numérico, contendo 10 ou 11 caracteres;',
                'pessoa_data_nascimento' : 'O campo deve estar no formato DD/MM/AAAA',
                'pessoa_filhos' : 'O campo deve ser numérico',
                'pessoa_observacao' : '',
                'endereco_cep': '',
                'endereco_estado': '',
                'endereco_cidade': '',
                'endereco_bairro': '',
                'endereco_logradouro': '',
                'endereco_numero': '',
                'endereco_complemento': '',
                'endereco_comercial_cep': '',
                'endereco_comercial_estado': '',
                'endereco_comercial_cidade': '',
                'endereco_comercial_bairro': '',
                'endereco_comercial_logradouro': '',
                'endereco_comercial_numero': '',
                'endereco_comercial_complemento': '',
                'beneficiario_nome' : '',
                'beneficiario_data_nascimento' : 'O campo deve estar no formato DD/MM/AAAA',
                'produto': 'O nome de um produto',
                'pedido_estagio': 'O campo deve ser 1 (Prospecção), 2 (Chamada Telefônica), 3 (Primeira Visita), 4 (Efetivado), 5 (Negativado), 6 (Segunda Visita), 7 (Em Espera), 8 (Perdido), 9 (Em Negociação)',
                'plataforma_origem': 'O campo deve ser 1 (Segasp), 2 (Própria)',
                'funcionario_id' : 'Deve ser um ID do funcionário existente na tabela',
            },

            funcionarios: null,

            pesquisa_funcionarios: {},
            salvandoLote: false,
        }
    },

    methods: {
        async enviarCsv(event)
        {
            const file = event.target.files[0];
            event.target.value = '';

            const form = new FormData();

            form.append('arquivo', file);

            const {data: {result: {data: itens}}} = await api.post('cliente/importar-csv', form);

            this.itens = itens;
        },

        exportarModelo() {

            const blob = new Blob([this.nomeCampos.join(',')], {type: 'text/csv;chartset=utf-8'});

            const link = document.createElement('a');

            Object.assign(link, {
                download: 'modelo.csv',
                href: URL.createObjectURL(blob)
            })

            link.click();
        },

        async salvarLote()
        {
            this.salvandoLote = true;

            const {data: {result: {data: dados}}} = await api.post('cliente/salvar-lote', {
                clientes: this.itens.map(item => item.dados)
            });

            this.salvandoLote = false;

            let mensagem = `Foram importado(s) ${dados.importados} registro(s).`;

            if (dados.invalidos.length) {
                mensagem += `\nHá ${dados.invalidos.length} registro(s) invalido(s) não importados.`
            }

            this.$swal({title: 'Sucesso!', text: mensagem});

            this.itens = dados.invalidos;
        },

        carregarFuncionarios: debounce(async function () {

            const {data: {result: {data: funcionarios}}} = await api.get('funcionario', {
                params:  { limit: 10, ...this.pesquisa_funcionarios }
            });

            this.funcionarios = funcionarios;

        }, 500)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clientes/Importacao.vue